module.exports = function confirmOptIn({ appId, pageId, ref, userRef }) {
  FB.AppEvents.logEvent("MessengerCheckboxUserConfirmation", null, {
    app_id: appId,
    page_id: pageId,
    ref: ref,
    user_ref: userRef
  });
};



/** WEBPACK FOOTER **
 ** ../src/common/facebookMessengerConfirm.js
 **/